import { render, staticRenderFns } from "./DetailedSlotFree.vue?vue&type=template&id=c5330a32&"
import script from "./DetailedSlotFree.vue?vue&type=script&lang=ts&"
export * from "./DetailedSlotFree.vue?vue&type=script&lang=ts&"
import style0 from "./DetailedSlotFree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports